import { Button, Container } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import React from "react";
import PageTitle from "../components/PageTitle";
import { useTranslation } from "react-i18next";

const NotFoundPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Container>
      <Helmet>
        <title>{t("notFound.metaTitle")}</title>
        <meta name="description" content={t("notFound.metaDescription")} />
      </Helmet>

      <PageTitle>{t("notFound.title")}</PageTitle>

      <Button variant="contained" color="primary" onClick={() => navigate(-1)}>
        {t("common.back")}
      </Button>
    </Container>
  );
};

export default NotFoundPage;
